
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 727.85 840"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Ebene_1"}},[_c('path',{attrs:{"d":"M109.67 768.55l-63.06 63.06c-8.68 8.68-18.62 10.62-29.82 5.83C5.59 832.64 0 824.07 0 811.74V384.71c0-15.08 5.37-27.99 16.11-38.73 10.74-10.74 23.65-16.11 38.73-16.11h438.69c15.08 0 27.99 5.37 38.73 16.11s16.11 23.65 16.11 38.73v329.01c0 15.08-5.37 27.99-16.11 38.73-10.74 10.74-23.65 16.11-38.73 16.11H109.67zm-23.3-54.83h407.15V384.71H54.84v359.86l31.53-30.85zm-31.53 0V384.71v329.01z"}}),_c('path',{attrs:{"d":"M643.53 187.32l23.52-52.1 52.1-23.52c11.61-5.36 11.61-21.73 0-27.09l-52.1-23.52L643.53 8.7c-5.36-11.61-21.73-11.61-27.09 0l-23.52 52.1-52.39 23.52c-11.61 5.36-11.61 21.73 0 27.09l52.1 23.52 23.52 52.39c5.36 11.61 22.03 11.61 27.39 0zm-236.96 44.65l-47.33-104.19c-10.42-23.22-43.76-23.22-54.18 0l-47.33 104.19-104.19 47.33c-23.22 10.72-23.22 43.76 0 54.18l104.19 47.33L305.06 485c10.72 23.22 43.76 23.22 54.18 0l47.33-104.19 104.19-47.33c23.22-10.72 23.22-43.76 0-54.18l-104.19-47.33zm209.57 193.5l-23.52 52.1-52.1 23.52c-11.61 5.36-11.61 21.73 0 27.09l52.1 23.52 23.52 52.39c5.36 11.61 21.73 11.61 27.09 0l23.52-52.1 52.39-23.52c11.61-5.36 11.61-21.73 0-27.09l-52.1-23.52-23.52-52.39c-5.36-11.61-22.03-11.61-27.39 0z"}})])])
          )
        }
      }
    